import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Box } from "@mui/system";
import { GetSummaryColorCode } from "../../../../app/utils/util";
import { useEffect, useState } from "react";
import React from "react";
import AppInformationText from "../../../../app/components/AppInformationText";
import { useAppSelector } from "../../../../app/store/configureStore";

export function ActivitiesAcrossDomains() {
    const { activitiesAcrossDomains } = useAppSelector(state => state.pcsPdp);
    const { currentYear } = useAppSelector(state => state.pcs);

    const [uniqueYears, setUniqueYears] = useState<number[]>();
    const [hasActivityAcrossDomains, setHasActivityAcrossDomains] = useState<boolean>(false);

    useEffect(() => {
        if (activitiesAcrossDomains !== null && currentYear !== null && setUniqueYears !== null) {

            let years: number[] = [];

            for (let year = currentYear - 1; year >= currentYear - 3; year--) {
                if (activitiesAcrossDomains && activitiesAcrossDomains?.summaryData &&
                    activitiesAcrossDomains?.summaryData?.filter(x => x.year === year).length > 0) {
                    years.push(year);
                }
            }
            setUniqueYears(years);

            if (years.length > 0) {
                setHasActivityAcrossDomains(true);
            }
        }
    }, [currentYear, activitiesAcrossDomains]);

    const getActivity = (year: number, domainCode: string) => {
        let domainId = activitiesAcrossDomains?.domains?.find(x => x.code === domainCode)?.id;
        return activitiesAcrossDomains?.summaryData?.find(x => x.year === year && x.domainId === domainId);
    }

    const setColor = (value: number | undefined) => {
        if (value === 0) return GetSummaryColorCode("RED");
        return GetSummaryColorCode("WHITE");
    }

    return <>
        {hasActivityAcrossDomains &&
            <Box sx={{
                "& .MuiPaper-root": {
                    width: "unset",
                    marginLeft: "0"
                }
            }}>
                <Box sx={{ minWidth: "100%", display: { xs: 'none', sm: 'block' } }}>
                    <Grid container rowSpacing={4} sx={{ paddingTop: "5%", paddingBottom: "2%" }}>

                        <Grid size={{ xs: 10, md: 3.5, sm: 5 }}>
                            <Typography variant='h5' sx={{ fontWeight: '550' }}>Activities across domains</Typography>
                        </Grid>

                        <Grid size={{ xs: 1, md: 1, sm: 1 }} sx={{ marginTop: '-7px' }}>
                            <AppInformationText information_text={'A red highlighted cell indicates no credits have been achieved in this domain.'} placement={"top"} />
                        </Grid>

                        <Grid size={{ xs: 1, md: 7.5, sm: 6 }}></Grid>
                    </Grid>

                    <Box sx={{ minWidth: "90%", width: "98%" }}>
                        <Grid container columns={18} sx={{ paddingBottom: '2%' }}>
                            <Grid size={{ xs: 2 }} sx={{
                                textAlign: 'start', paddingRight: '1%', fontSize: '15px'
                            }}>
                                <b>PCS Year</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Clinical Skills</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Collaborative & Teamwork</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Communication & Interpersonal Skills</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Management (including Self Management)</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Patient Safety & Quality of Patient Care</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Professionalism</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Relating to Patients</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%', fontSize: '15px' }}>
                                <b>Scholarship</b>
                            </Grid>
                        </Grid>

                        {uniqueYears && uniqueYears.map((year: number, index: number) => (
                            <React.Fragment key={index}>

                                <Grid container columns={18} sx={{ width: '100%', padding: '1px' }}>

                                    <Grid size={{ xs: 2 }}>
                                        <Grid sx={{ textAlign: 'start', paddingTop: '16px' }}>
                                            {`${year} - ${year + 1}`}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "CS")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "CS")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "C&T")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "C&T")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "CIS")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "CIS")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "MGMT")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "MGMT")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "PSQPC")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "PSQPC")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "PFM")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "PFM")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "SCP")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "RP")?.total}
                                        </Grid>
                                    </Grid>

                                    <Grid size={{ xs: 2 }} sx={{ padding: 1 }}>
                                        <Grid sx={{
                                            backgroundColor: setColor(getActivity(year, "SCP")?.total),
                                            textAlign: 'center',
                                            padding: 1,
                                            paddingTop: '16px'
                                        }}>
                                            {getActivity(year, "SCP")?.total}
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </React.Fragment>
                        ))
                        }

                    </Box>
                </Box>
            </Box >
        }
    </>
}
